import { render, staticRenderFns } from "./StepperAditivoApostila.vue?vue&type=template&id=52031181"
import script from "./StepperAditivoApostila.vue?vue&type=script&lang=js"
export * from "./StepperAditivoApostila.vue?vue&type=script&lang=js"
import style0 from "./StepperAditivoApostila.vue?vue&type=style&index=0&id=52031181&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports